<template>
  <Step2Body/>
</template>

<script>
// @ is an alias to /src
import Step2Body from '@/components/Step2Body.vue'

export default {
  name: 'Step2View',
  components: {
    Step2Body
  }
}
</script>
